import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { LiteralService } from 'src/app/services';

@Component({
    selector: 'app-multiselect-checkboxes',
    templateUrl: './multiselect-checkboxes.component.html',
    styleUrl: './multiselect-checkboxes.component.scss',
    standalone: false
})
export class MultiselectCheckboxesComponent {
  @Input() title: string;
  @Input() elements?: any[] = [];
  @Input() values?: any[];
  @Input() translateValue?: boolean;
  @Input() extraInfo?: string;
  @Output() changeEventEmitter = new EventEmitter<unknown>();

  @HostListener('click', ['$event'])
  onClick(event: any) {
    if (!this.values) return;

    const element = this.elements?.find((el: any) => el.id == event.target.id || el == event.target.id);
    if (!element) return;

    const index = this.values.findIndex((val: any) => val.id == element.id || val == element);

    event.target.checked
      ? this.values.push(element)
      : index !== -1 && this.values.splice(index, 1);
  }

  constructor(public literalService: LiteralService) {}

  public checked(item: any) {
    return this.values?.find((value: any) => value && value.id === item.id);
  }
}
